/**
 * (Группа 9) Поставщики — модерация и KYC.
 *
 * Backend модуль vendor существует (REAL /v1/admin/vendors), детальные
 * экраны модерации/KYC — каркас.
 */
import { PageStub } from '../../shared/PageStub.js';

export function VendorsPage(): JSX.Element {
  return (
    <PageStub
      testId="vendors-page"
      title="Поставщики"
      description="Очередь модерации поставщиков, проверка KYC, решения approve/reject."
      sections={[
        'Список поставщиков + очередь модерации (старше 24ч выделены)',
        'Карточка поставщика: ИНН, сайт, документы KYC, контакты, услуги',
        'Модальное окно approve (условия, выбор отелей)',
        'Модальное окно reject (обязательная причина, окно повторной заявки 30 дней)',
      ]}
      dataSource="REAL /v1/admin/vendors (backend vendor module); экраны модерации — каркас"
    />
  );
}
